import winston from 'winston';
import { IncomingHttpHeaders } from 'http';
import { getAccessToken } from '@doda/common/src/services/getAccessToken';
import { getAbTestResumeScreeningScoreFilteringGroupNo } from '@doda/common/src/services/getAbTestResumeScreeningScoreFilteringGroupNo';
import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';
import { AbTestResumeScreeningScoreFilteringGroupNoResponseCode } from '@doda/api-client/aspida/@types';
import {
  TopResumeScoreFilteringType,
  TOP_RESUME_SCORE_FILTERING_RECOMMEND_TYPE,
  TOP_RESUME_SCORE_FILTERING_LINK_NAMES,
  NON_TARGET_AB_TEST,
} from '../constants/topResumeScoreFiltering';

/**
 * DODASITE-792_書類通過スコア0.05以下の足切り×通過注力セグメント
 * ABテスト振分け用グループNoを取得する
 *
 * @param dcfrontHeaders dcfront系APIに渡すheader情報
 * @param logger ロガー
 * @returns ABテスト振分け用グループNo
 */
export const fetchTopResumeScoreFilteringGroupNo = async (
  dcfrontHeaders: IncomingHttpHeaders,
  logger: winston.Logger
): Promise<AbTestResumeScreeningScoreFilteringGroupNoResponseCode> => {
  try {
    const accessToken = await getAccessToken(dcfrontHeaders);
    if (!accessToken) throw new Error('failed to get accessToken');

    const response = await getAbTestResumeScreeningScoreFilteringGroupNo({
      authorization: `Bearer ${accessToken}`,
    });

    return response.groupNo;
  } catch (error) {
    logger.error(error);
    return NON_TARGET_AB_TEST;
  }
};

/**
 * DODASITE-792_書類通過スコア0.05以下の足切り×通過注力セグメント
 * ABテスト振分け用グループNoをABテスト振分け用グループ種別に変換する
 *
 * @param groupNo ABテスト振分け用グループNo
 * @returns {AbTestResumeScreeningScoreFilteringGroupNoResponseCode} ABテスト振分け用グループ種別
 */
export const convertIntoTopResumeScoreFilteringType = (
  groupNo: AbTestResumeScreeningScoreFilteringGroupNoResponseCode
): TopResumeScoreFilteringType => {
  switch (groupNo) {
    case '1':
      return 'ORIGINAL';
    case '2':
      return 'TEST_B';
    case '3':
      return 'TEST_C_APPLICANT';
    case '4':
      return 'TEST_C_PASSER';
    default:
      return 'EXCLUDED';
  }
};

/**
 * レコメンド種別を作成する
 *
 * @param topResumeScoreFilteringType
 * @param topB4rTsuukaRecommendType
 * @returns レコメンド種別
 */
export const createRecommendType = (
  topResumeScoreFilteringType: TopResumeScoreFilteringType,
  topB4rTsuukaRecommendType: 'ORIGINAL' | 'TEST' | 'FAILED'
) => {
  if (['TEST_B', 'TEST_C_PASSER'].includes(topResumeScoreFilteringType))
    return TOP_RESUME_SCORE_FILTERING_RECOMMEND_TYPE;
  if (topB4rTsuukaRecommendType === 'TEST')
    return 'b4r_cbm_gousei_rerank_recommend';
  return 'AWS_Recommend_oubo';
};

/**
 * DODASITE-792_書類通過スコア0.05以下の足切り×通過注力セグメント
 * imp計測
 *
 * @param topResumeScoreFilteringType
 */
export const measureTopResumeScoreFilteringAnalytics = (
  topResumeScoreFilteringType: TopResumeScoreFilteringType
) => {
  const linkName =
    TOP_RESUME_SCORE_FILTERING_LINK_NAMES[topResumeScoreFilteringType];
  if (linkName) tl(linkName, {});
};
